import { useState, useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { X, Plus, Trash2, Coins } from "lucide-react";

const num = (v) => Number(v) || 0;

export default function AltinSozlesmeDialog({ open, onClose, onDone }) {
  const [f, setF] = useState({ musteri: "", tc_no: "", telefon: "", adres: "", urun: "", satis_gram: "", alis_gram: "", pesinat_usd: "" });
  const [vadeler, setVadeler] = useState([{ vade_tarihi: "", tutar_usd: "" }]);
  const [rate, setRate] = useState(0);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  useEffect(() => {
    if (open) api.get("/altin/fiyatlar").then((r) => setRate(r.data?.usd_gram_altin?.satis || 0)).catch(() => {});
  }, [open]);

  if (!open) return null;

  const setVade = (i, k, v) => setVadeler((p) => p.map((x, idx) => (idx === i ? { ...x, [k]: v } : x)));
  const addVade = () => setVadeler((p) => [...p, { vade_tarihi: "", tutar_usd: "" }]);
  const delVade = (i) => setVadeler((p) => p.filter((_, idx) => idx !== i));
  const toplamUsd = vadeler.reduce((a, v) => a + num(v.tutar_usd), 0) + num(f.pesinat_usd);

  const submit = async () => {
    if (!f.musteri.trim()) return toast.error("Müşteri adı gerekli");
    setBusy(true);
    try {
      const body = {
        musteri: f.musteri, tc_no: f.tc_no, telefon: f.telefon, adres: f.adres, urun: f.urun,
        satis_gram: num(f.satis_gram), alis_gram: num(f.alis_gram), pesinat_usd: num(f.pesinat_usd),
        vadeler: vadeler.filter((v) => v.vade_tarihi).map((v) => ({ vade_tarihi: v.vade_tarihi, tutar_usd: num(v.tutar_usd) })),
      };
      const { data } = await api.post("/altin/sozlesme-create", body);
      toast.success(`Altın sözleşmesi oluşturuldu (${data.created} vade, peşinat ${data.pesinat_gram} gr)`);
      onDone?.();
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Oluşturulamadı"); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4 overflow-auto">
      <div className="bg-white border border-[#E7DECC] rounded-sm w-full max-w-2xl my-8" data-testid="altin-sozlesme-dialog">
        <div className="flex items-center justify-between px-5 py-3 border-b border-[#E7DECC]">
          <span className="font-heading font-bold flex items-center gap-2"><Coins className="w-4 h-4 text-[#B8933F]" /> Yeni Altın Sözleşmesi</span>
          <button onClick={onClose} className="text-[#8C8377] hover:text-[#26231E]"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-4">
          <div className="text-xs text-[#8C8377]">Anlık USD/gram altın: <b className="text-[#B8933F]">{rate ? rate.toFixed(2) : "—"} $/gr</b></div>
          <div className="grid grid-cols-2 gap-3">
            <Inp label="MÜŞTERİ" v={f.musteri} on={(v) => set("musteri", v)} tid="alt-musteri" />
            <Inp label="TC NO" v={f.tc_no} on={(v) => set("tc_no", v)} tid="alt-tc" />
            <Inp label="TELEFON" v={f.telefon} on={(v) => set("telefon", v)} tid="alt-tel" />
            <Inp label="ÜRÜN" v={f.urun} on={(v) => set("urun", v)} tid="alt-urun" />
            <Inp label="SATIŞ (GRAM)" v={f.satis_gram} on={(v) => set("satis_gram", v)} tid="alt-satis-gram" type="number" />
            <Inp label="ALIŞ (GRAM)" v={f.alis_gram} on={(v) => set("alis_gram", v)} tid="alt-alis-gram" type="number" />
            <Inp label="PEŞİNAT (USD)" v={f.pesinat_usd} on={(v) => set("pesinat_usd", v)} tid="alt-pesinat" type="number" />
            <Inp label="ADRES" v={f.adres} on={(v) => set("adres", v)} tid="alt-adres" />
          </div>
          <div>
            <div className="flex items-center justify-between mb-2">
              <span className="kicker text-[#B8933F]">VADELER (USD)</span>
              <button onClick={addVade} data-testid="alt-add-vade" className="inline-flex items-center gap-1 text-xs px-2 py-1 border border-[#E7DECC] rounded-sm hover:bg-[#F3ECDD]"><Plus className="w-3 h-3" /> Vade Ekle</button>
            </div>
            <div className="space-y-2">
              {vadeler.map((v, i) => (
                <div key={i} className="flex gap-2 items-center">
                  <input type="date" value={v.vade_tarihi} onChange={(e) => setVade(i, "vade_tarihi", e.target.value)} data-testid={`alt-vade-tarih-${i}`} className="flex-1 px-2 py-1.5 border border-[#E7DECC] rounded-sm text-sm" />
                  <input type="number" placeholder="USD" value={v.tutar_usd} onChange={(e) => setVade(i, "tutar_usd", e.target.value)} data-testid={`alt-vade-usd-${i}`} className="w-32 px-2 py-1.5 border border-[#E7DECC] rounded-sm text-sm" />
                  <button onClick={() => delVade(i)} className="text-[#A63A3A] p-1"><Trash2 className="w-4 h-4" /></button>
                </div>
              ))}
            </div>
          </div>
          <div className="text-sm text-[#6B6459]">Toplam (peşinat dahil): <b>{toplamUsd.toLocaleString("tr-TR")} $</b>{rate ? ` ≈ ${(toplamUsd / rate).toFixed(3)} gr` : ""}</div>
        </div>
        <div className="flex justify-end gap-2 px-5 py-3 border-t border-[#E7DECC]">
          <button onClick={onClose} className="px-4 py-2 border border-[#E7DECC] rounded-sm text-sm">İptal</button>
          <button onClick={submit} disabled={busy} data-testid="alt-sozlesme-submit" className="px-5 py-2 bg-[#B8933F] hover:bg-[#9C7A33] text-white rounded-sm text-sm font-medium disabled:opacity-50">{busy ? "Kaydediliyor…" : "Oluştur"}</button>
        </div>
      </div>
    </div>
  );
}

function Inp({ label, v, on, tid, type = "text" }) {
  return (
    <div>
      <label className="kicker block mb-1">{label}</label>
      <input type={type} value={v} onChange={(e) => on(e.target.value)} data-testid={tid} className="w-full px-3 py-2 border border-[#E7DECC] rounded-sm text-sm focus:outline-none focus:border-[#B8933F]" />
    </div>
  );
}
